Librarian.Search.Panel = new Class({
    Extends: MUI.Panel,
    Implements: Librarian.Search.Container,
    Binds: ["onSearchLoaded", "onReturnTypeChanged", "loadSearchOptions", "onSearchForChanged",
            "onSearchWithinClicked", "closeCatSelectWindow", "onAttributesLoaded", "onMetaCategorySelectClicked",
            "onSearchFileTypeAddClicked", "onSearchFileTypeRemoveClicked", "onFileTypesLoaded",
            "loadRequestDataList", "loadFileTypeList", "getFileTypeExtensions", "submit",
            "useLastSearchOptions", "useSearchOptions", "clearSearch", "doSearchTerm"],

    options: {
        id: "searchPanel",
        resizable: false,
        width: 260
    },

    loaded: false,
    fileTypes: null,
    catSelectWindow: null,
    selectedOptionType: '',
    searchMatchRules: {
        "Any Words": "OR",
        "All Words": "AND",
        "Exact Phrase": "EXACT"
    },

    initialize: function(options) {
        this.setOptions(options);
        this.options.contentURL = Librarian.path.getLibraryPath() + "search.html?" + Librarian.buildVersion;

        this.options.onContentLoaded = this.onContentLoaded;
        this.options.onShow = this.onShow;

        this.parent(this.options);
    },

    onContentLoaded: function() {
        this.hide();
    },

    onShow: function() {
        if (!this.loaded) {
            this.loaded = true;
            this.loadPanel();
        }
    },

    loadPanel: function() {
        this.onSearchLoaded({ id: this.options.id });

        var itemEl = $("searchReturnType");
        if (itemEl)
            itemEl.addEvent("change", this.onReturnTypeChanged);

        itemEl = $$("[name=subType]");
        itemEl.each(function(el) {
            if (el.get("tag") == "select") {
                el.addEvent("change", function() {
                    var selectedEl = el.getElement(":selected");
                    this.onSearchForChanged(selectedEl);
                }.bind(this));

                var selectedEl = el.getElement(":selected");
                if (selectedEl) {
                    this.onSearchForChanged(selectedEl);
                }
            } else {
                el.addOnClick(function(e) {
                    var evt = new Event(e);
                    this.onSearchForChanged($(evt.target));
                }, this);

                if (el.checked)
                    this.onSearchForChanged(el);
            }
        }.bind(this));

        itemEl = $$(".subType");
        itemEl.each(function (el, index, obj) {
            el.addOnClick(function (e) {
                obj.getParent("li").removeClass("selected");
                el.getParent("li").addClass("selected");
                var evt = new Event(e);
                this.onSearchForChanged($(evt.target));
            }, this);

            if (el.getParent("li").hasClass("selected"))
                this.onSearchForChanged(el);
        }.bind(this));

        itemEl = $$(".searchTermRule");
        itemEl.each(function(el, index, obj) {
            el.addOnClick(function() {
                obj.removeClass("selected");
                el.addClass("selected");
            });
        });

        itemEl = $$(".search-term");
        itemEl.each(function(el) {
            el.setAttribute("placeholder", Librarian.Lang.getString("search_advanced_empty"));
        }.bind(this));

        itemEl = $("searchPresentationContent");
        if (itemEl) {
            itemEl.addOnClick(function() {
                this.onContentChecked($("searchPresentationContent"), ".search-pres-content");
            }, this);
        }

        itemEl = $$(".search-pres-content");
        itemEl.each(function(el) {
            el.addOnClick(function() {
                this.onContentItemChecked($("searchPresentationContent"), ".search-pres-content");
            }, this);
        }.bind(this));

        itemEl = $("searchFilesContent");
        if (itemEl) {
            itemEl.addOnClick(function() {
                this.onContentChecked($("searchFilesContent"), ".search-files-content");
            }, this);
        }

        itemEl = $$(".search-files-content");
        itemEl.each(function(el) {
            el.addOnClick(function() {
                this.onContentItemChecked($("searchFilesContent"), ".search-files-content");
            }, this);
        }.bind(this));

        itemEl = $("searchGroupContent");
        if (itemEl) {
            itemEl.addOnClick(function() {
                this.onContentChecked($("searchGroupContent"), ".search-group-content");
            }, this);
        }

        itemEl = $$(".search-group-content");
        itemEl.each(function(el) {
            el.addOnClick(function() {
                this.onContentItemChecked($("searchGroupContent"), ".search-group-content");
            }, this);
        }.bind(this));

        var disableSearchWithin = true;
        itemEl = $("searchWithinAll");
        if (itemEl) {
            itemEl.addOnClick(this.onSearchWithinAllClicked);

            if (itemEl.checked)
                disableSearchWithin = true;
        }

        itemEl = $("searchWithinText");
        if (itemEl) {
            itemEl.set("disabled", disableSearchWithin);
            this.loadSelectedCategoryName();
        }

        itemEl = $("searchWithinButton");
        if (itemEl) {
            if (disableSearchWithin)
                itemEl.addClass("disabled");
            itemEl.set("disabled", disableSearchWithin);
            itemEl.addOnClick(this.onSearchWithinClicked);
        }

        itemEl = $("searchContentMetaLists");
        if (itemEl) {
            (function() {
                var attrLoadedCount = 2;
                var attrs = [];
                var self = this;

                var onFileAndGroupMetaListLoaded = function(data) {
                    attrLoadedCount--;
                    attrs = attrs.concat(data.data);

                    if (!attrLoadedCount) {
                        var intersectAttr = [];

                        for (var i = 0, len = attrs.length; i < len; i++) {
                            var isDuplicate = false;
                            for (var j = 0, len2 = intersectAttr.length; j < len2; j++) {
                                if (intersectAttr[j].id === attrs[i].id) {
                                    isDuplicate = true;
                                    intersectAttr[j].contentType = intersectAttr[j].contentType + ";" + attrs[i].contentType;
                                    break;
                                }
                            }

                            if (!isDuplicate) {
                                intersectAttr.push(attrs[i]);
                            }
                        }

                        self.onAttributesLoaded({
                            data: intersectAttr
                        }, $("searchContentMetaLists"));
                    }
                }

                var fileMeta = $("searchFilesMetaLists");
                if (fileMeta) {
                    fileMeta.addEvent("attributesLoaded", onFileAndGroupMetaListLoaded);
                }

                var groupMeta = $("searchGroupsMetaLists");
                if (groupMeta) {
                    groupMeta.addEvent("attributesLoaded", onFileAndGroupMetaListLoaded);
                }
            }).call(this);
        }

        itemEl = $("searchFilesMetaLists");
        if (itemEl) {
            var request = new Librarian.Request.JSON({
                url: Librarian.path.getMethodUrl("getfatl") + "&all=0&out=dgrid",
                onFailure: Librarian.Utils.onFailure,
                onSuccess: function(json) {
                    json.data = json.data.map(function(datum) {
                        datum.contentType = Librarian.contentType.file;
                        return datum;
                    });
                    this.onAttributesLoaded(json, $("searchFilesMetaLists"));
                }.bind(this)
            });
            request.send();
        }

        itemEl = $("searchSlidesMetaLists");
        if (itemEl) {
            var request = new Librarian.Request.JSON({
                url: Librarian.path.getMethodUrl("getsatl") + "&all=0&out=dgrid",
                onFailure: Librarian.Utils.onFailure,
                onSuccess: function(json) {
                    json.data = json.data.map(function(datum) {
                        datum.contentType = Librarian.contentType.slide;
                        return datum;
                    });
                    this.onAttributesLoaded(json, $("searchSlidesMetaLists"));
                }.bind(this)
            });
            request.send();
        }

        itemEl = $("searchGroupsMetaLists");
        if (itemEl) {
            var request = new Librarian.Request.JSON({
                url: Librarian.path.getMethodUrl("getgatl") + "&all=0&out=dgrid",
                onFailure: Librarian.Utils.onFailure,
                onSuccess: function(json) {
                    json.data = json.data.map(function(datum) {
                        datum.contentType = Librarian.contentType.contentGroup;
                        return datum;
                    });
                    this.onAttributesLoaded(json, $("searchGroupsMetaLists"));
                }.bind(this)
            });
            request.send();
        }

        itemEl = $("searchFileTypeAddButton");
        if (itemEl)
            itemEl.addOnClick(this.onSearchFileTypeAddClicked);

        itemEl = $("searchFileTypeRemoveButton");
        if (itemEl)
            itemEl.addOnClick(this.onSearchFileTypeRemoveClicked);

        itemEl = $("searchRequestDataCont");
        if (itemEl && (typeOf(Librarian.search.requestDataList) == "array") && (Librarian.search.requestDataList.length > 0)) {
            itemEl.show();
            this.loadRequestDataList();
        }

        $$(".search-file-type").each(function(el) {
            el.addEvent("change", this.loadSearchOptions);
        }.bind(this));

        Librarian.Utils.getFileTypes(this.onFileTypesLoaded);

        itemEl = $("searchSubmit");
        if (itemEl)
            itemEl.addOnClick(this.submit);

        itemEl = $("clear_advance_search");
        if (itemEl)
            itemEl.addOnClick(this.clearSearch);

        this.onReturnTypeChanged();
        Librarian.Lang.translateElements(this.windowEl);

        itemEl = null;
    },

    onContentChecked: function(checkEl, checksClass) {
        if (!checkEl)
            return;

        var checks = $$(checksClass);
        // Set the check state of all the children to match the parent
        for (var i = 0; i < checks.length; i++)
            checks[i].set("checked", checkEl.checked);
    },

    onContentItemChecked: function(checkEl, checksClass) {
        if (!checkEl)
            return;

        var checks = $$(checksClass),
            checked = 0;
        // Count how many of the child check marks are checked
        for (var i = 0; i < checks.length; i++) {
            if (checks[i].checked)
                checked++;
        }

        // If they are all checked, check the parent
        if (checked == checks.length)
            checkEl.set("checked", true);
        // Otherwise, uncheck it
        else
            checkEl.set("checked", false);
    },

    onReturnTypeChanged: function(showFileSubOptions) {
        var selectEl = $("searchReturnType");
        if (!selectEl)
            return;

        var selectedIndex = Math.max(0, selectEl.selectedIndex || 0),
            optionid = "searchReturn" + selectEl.options[selectedIndex].value.toCapitalCase() + "Options",
            excludeList = [];

        var subType = this.getSelectedSubType();
        // If there is a "Search For" list, get the exluded return type options list, if it has one
        if (subType)
            excludeList = subType.returnType.optionExcludes || [];

        var shownAttrib = {},
            shownOption = {};
        for (var i = 0, length = Librarian.Search.Panel.returnTypes.length; i < length; i++) {
            var enabled = Librarian.Search.Panel.returnTypes[i].enabled;
            if (typeof enabled == "function")
                enabled = enabled();

            var name = Librarian.Search.Panel.returnTypes[i].name.trim(),
                optionType = Librarian.Search.Panel.returnTypes[i].getOptionType(),
                attribType = Librarian.Search.Panel.returnTypes[i].attribType.toCapitalCase().trim(),
                id = "searchReturn" + optionType + "Options",
                optionsEl = $(id);

            // If this is the target item and it's not in the options exclude list, show the options
            if (enabled && (id == optionid) && !excludeList.contains(name)) {
                if (optionsEl)
                    optionsEl.show();

                var wasGroup = false, isGroup = false;
                if (this.selectedOptionType.length > 0) {
                    wasGroup = this.selectedOptionType.contains("Group");
                    isGroup = optionType.contains("Group");
                }

                this.selectedOptionType = optionType;

                // If we're switching from groups to non-groups, reload the selected categories
                if (wasGroup != isGroup)
                    this.loadSelectedCategoryName();

                if (optionType == "Files") {
                    var subOptionsEl = $("searchReturn" + optionType + "SubOptions");
                    if (subOptionsEl) {
                        if (showFileSubOptions !== false)
                            subOptionsEl.show();
                        else
                            subOptionsEl.hide();
                    }
                }

                // Show the attribute list if there are attributes to select
                var listEl = $("search" + attribType + "MetaLists");
                var show = (listEl && (listEl.getChildren().length > 0));
                this.showAttributeOptions(attribType, show, show);

                // Keep track of what we've shown already so it doesn't get hidden laster
                shownAttrib[attribType] = show;
                shownOption[optionType] = true;

                this.loadSearchOptions();

                // Do not show category selection if searching for content
                var searchWithin = $("search-within-category");
                if (searchWithin) {
                    if (name == "Content") {
                        searchWithin.hide();
                    } else {
                        searchWithin.show();
                    }
                }
            }
            // If these haven't already been shown, hide them
            else  {
                if ((shownOption[optionType] !== true) && optionsEl)
                    optionsEl.hide();

                if (shownAttrib[attribType] !== true)
                    this.showAttributeOptions(attribType, false);
            }

        }
    },

    showAttributeOptions: function(type, show, showContainer) {
        var attrEl = $("search" + type + "Attributes");
        if (attrEl) {
            if (show)
                attrEl.show();
            else
                attrEl.hide();
        }

        if (typeof showContainer == "boolean") {
            var contEl = $("searchAttributes");
            if (contEl) {
                if (showContainer)
                    contEl.show();
                else
                    contEl.hide();
            }
        }
    },

    loadSearchOptions: function() {
        var selectEl = $("searchReturnType");
        if (!selectEl)
            return;

        var optionsEl = $(selectEl.options[selectEl.selectedIndex].id + "Options");
        if (!optionsEl)
            return;

        var optionEls = optionsEl.getElements(".search-option"),
            fileTypes = this.getSelectedFileTypes(),
            extensions = this.getFileTypeExtensions(),
            shown = 0;

        // Check each option
        for (var i = 0; i < optionEls.length; i++) {
            var types = optionEls[i].getAttribute("types"),
                show = false;

            // If there are types
            if (types != null) {
                types = types.split(';');

                // Make sure at least one of the types we have available is in the list of types for this option
                for (var j = 0; j < types.length; j++) {
                    var hasType = extensions.some(function(extension) {
                        return extension.toLowerCase().startsWith(types[j].toLowerCase());
                    });

                    if (hasType) {
                        // If the type is present, make sure the type we have selected is "All Types" or one of them as well
                        show = ((fileTypes.length == 1) && (fileTypes[0] == "all types")) || fileTypes.some(function(fileType) {
                            return fileType.startsWith(types[j].toLowerCase());
                        });
                        break;
                    }
                }
            }
            else
                show = true;

            // Keep track of how many options are shown
            if (show) {
                optionEls[i].show();
                shown++;
            }
            else
                optionEls[i].hide();
        }

        // If no options are available, hide the container
        if (shown == 0)
            optionsEl.hide();
        else
            optionsEl.show();
    },

    loadRequestDataList: function() {
        var contEl = $("searchRequestData");
        if (!contEl)
            return;

        var data = Array.from(Librarian.search.requestDataList);
        for (var i = 0, length = data.length; i < length; i++) {
            var requestContEl = new Element("div", { "class": "pure-g-r search-request-container" }).injectInside(contEl);
            new Element("div", { "class": "pure-u-1-3 search-request-name", "text": data[i] }).injectInside(requestContEl);
            var requestInputContEl = new Element("div", { "class": "pure-u-2-3" }).injectInside(requestContEl);

            new Element("input[type=text]", {
                "class": "search-request-value",
                "spellcheck": "true"
            }).injectInside(requestInputContEl);
        }
    },

    getSelectedFileTypes: function() {
        var fileTypes = [];

        // Build the list of selected file types
        $$(".search-file-type").each(function(el) {
            // Don't check this element if it's hidden
            if (!el.isVisible())
                return;

            var fileType = Librarian.Utils.getSelectedValue(el);
            if (fileType == null)
                return;

            fileType = fileType.toLowerCase();
            if ((fileType.length > 0) && !fileTypes.contains(fileType))
                fileTypes.push(fileType);
        });

        return fileTypes;
    },

    getSelectedSubType: function() {
        var subTypeEls = $$("[name=subType]"),
            check = function(type) {
                for (var j = Librarian.Search.Panel.searchFor.length; j--;) {
                    if (Librarian.Search.Panel.searchFor[j].name == type)
                        return Librarian.Search.Panel.searchFor[j];
                }
                return false;
            },
            type;
        if (subTypeEls.length > 0) {
            for (var i = subTypeEls.length; i--;) {
                var targetEl = subTypeEls[i];
                var value;

                if (targetEl.get("tag") == "select") {
                    value = Librarian.Utils.getElementValue(targetEl);
                } else {
                    if (targetEl.checked) {
                        value = targetEl.value;                     
                    }
                }

                if (value) {
                    type = check(value);
                }

                if (type) {
                    return type;
                }               
            }
        }
        else {
            // New style of search html uses tabs with className
            var itemEl = $$(".subTypeWrapper.selected")[0];
            if (itemEl) {
                itemEl = itemEl.getChildren()[0];
                if (itemEl) {
                    var retType = Librarian.Utils.getElementValue(itemEl);
                    if (retType) {
                        type = check(retType);
                        if (type)
                            return type;
                    }
                }
            }
        }
        return null;
    },

    onSearchForChanged: function(itemEl) {
        if (!itemEl)
            return;

        var fileTypeEl = $("searchFileTypes"),
            selectedType = Librarian.Utils.getElementValue(itemEl, true);

        // Go through each of the "Search for" options to find the one we want
        for (var i = Librarian.Search.Panel.searchFor.length; i--;) {
            if (selectedType == Librarian.Search.Panel.searchFor[i].name) {
                // Show or hide file types as needed
                if (fileTypeEl) {
                    if (Librarian.Search.Panel.searchFor[i].showFileTypes !== false) {
                        this.loadFileTypeList();
                        fileTypeEl.show();
                    }
                    else
                        fileTypeEl.hide();
                }

                // Get this "Search for" entry's return types
                var returnTypes = Librarian.Search.Panel.searchFor[i].returnType.types;
                if (returnTypes) {
                    var returnTypesEl = $("searchReturnType");
                    if (!returnTypesEl)
                        break;

                    returnTypesEl.options.length = 0;
                    returnTypesEl.selectedIndex = 0;

                    // Add each of the return types to the dropdown list
                    for (var j = 0, typeLength = Librarian.Search.Panel.returnTypes.length; j < typeLength; j++) {
                        if (!returnTypes.contains(Librarian.Search.Panel.returnTypes[j].getOptionType()))
                            continue;
                        if (Librarian.Search.Panel.returnTypes[j].enabled === false)
                            continue;
                        if ((typeof Librarian.Search.Panel.returnTypes[j].enabled == "function") && !Librarian.Search.Panel.returnTypes[j].enabled())
                            continue;

                        var optionName = Librarian.Search.Panel.getResultsOptionName(Librarian.Search.Panel.returnTypes[j].name),
                            optionEl = new Element("option", {
                                "text": optionName,
                                "value": Librarian.Search.Panel.returnTypes[j].getOptionType().toLowerCase(),
                                "id": "searchReturn" + Librarian.Search.Panel.returnTypes[j].getOptionType().replaceAll(' ', '')
                            });
                        if (Librarian.Search.Panel.returnTypes[j].select === true)
                            optionEl.set("selected", true);
                        optionEl.set("attribType", Librarian.Search.Panel.returnTypes[j].attribType);

                        returnTypesEl.appendChild(optionEl);
                    }

                    var parentEl = returnTypesEl.getParent();
                    if (parentEl)
                        parentEl[returnTypesEl.options.length == 1 ? "hide" : "show"]();

                    // Load the correct search options
                    this.onReturnTypeChanged(Librarian.Search.Panel.searchFor[i].showFileSubOptions);
                }
                break;
            }
        }
    },

    onSearchWithinAllClicked: function() {
        var checkEl = $("searchWithinAll");
        if (!checkEl)
            return;

        var searchWithinEl = $("searchWithinText");
        if (searchWithinEl)
            searchWithinEl.set("disabled", checkEl.checked);

        searchWithinEl = $("searchWithinButton");
        if (searchWithinEl) {
            searchWithinEl[(checkEl.checked ? "add" : "remove") + "Class"]("disabled");
            searchWithinEl.set("disabled", checkEl.checked);
        }
    },

    onSearchWithinClicked: function() {
        var searchWithinEl = $("searchWithinText");
        if (!searchWithinEl || searchWithinEl.disabled)
            return;
        var searchWithinIDEl = $("searchWithinID");
        if (!searchWithinIDEl)
            return;

        var catType = Librarian.catType.file;
        if (this.selectedOptionType.contains("Group"))
            catType = Librarian.catType.globalFavorite;

        this.closeCatSelectWindow();
        this.catSelectWindow = new Librarian.CategorySelectWindow({
            catType: catType,
            selectedCategories: Librarian.Utils.getElementValue(searchWithinEl),
            selectedCategoryIDs: Librarian.Utils.getElementValue(searchWithinIDEl),
            onCloseComplete: function() {
                Librarian.Utils.setElementValue(searchWithinEl, this.catSelectWindow.options.selectedCategories);
                Librarian.Utils.setElementValue(searchWithinIDEl, this.catSelectWindow.options.selectedCategoryIDs);
                this.catSelectWindow = null;
            }.bind(this)
        });
        this.catSelectWindow.show();
    },

    closeCatSelectWindow: function() {
        if (this.catSelectWindow) {
            this.catSelectWindow.close();
            this.catSelectWindow = null;
        }
    },

    onAttributesLoaded: function(json, contEl) {
        if (!json || !json.data || (json.data.length == 0) || !contEl)
            return;

        var metaList = json.data;
        for (var i = 0, length = metaList.length; i < length; i++) {
            if (!metaList[i].searchable)
                continue;

            var metaName = metaList[i].name.replaceAll(' ', ''),
                metaContEl = new Element("div", { "class": "pure-g-r search-meta-container" }).injectInside(contEl),
                type = metaList[i].contentType || "",
                id = (metaName + "Options-" + type).toCapitalCase(),
                metaNameClass = "search-meta-name";
            new Element("div", { "class": "pure-u-1-3", "html": "<span class='" + metaNameClass + "'>" + metaList[i].name + "</span>" }).injectInside(metaContEl);
            var metaInputContEl = new Element("div", { "class": "pure-u-2-3" }).injectInside(metaContEl);

            var metaValueClass = "search-meta-value";
            if (metaList[i].dropdown) {
                var selectEl = new Element("select", {
                    "id": id,
                    "class": metaValueClass,
                    "multiple": "multiple",
                    "contentType": type
                }).injectInside(metaInputContEl);

                // Load the values into the selects
                Librarian.Utils.getAttributeDropdownValues(metaList[i].id, metaList[i].name, this.onAttributeValuesLoaded.bind(selectEl));
            }
            else if (metaList[i].categorized) {
                new Element("input[type=text]", {
                    "id": id,
                    "class": metaValueClass + " search-meta-categorized",
                    "readonly": "readonly",
                    "contentType": type
                }).injectInside(metaInputContEl);
                var buttonEl = new Element("span", {
                    "id": id + "Button",
                    "class": "search-meta-categorized-button pointer",
                    "title": Librarian.Lang.getString("search_meta_select_categories")
                }).injectInside(metaInputContEl);

                buttonEl.addOnClick(this.onMetaCategorySelectClicked.pass([metaList[i], id]));
            }
            else if (metaList[i].datatype == Librarian.attributeDataType.bool) {
                var selectEl = new Element("select", {
                    "id": id,
                    "class": metaValueClass,
                    "contentType": type
                }).injectInside(metaInputContEl);
                Librarian.Utils.fillSelect(selectEl, ['', "true", "false"], true);
            }
            else if (metaList[i].datatype == Librarian.attributeDataType.datetime) {
                new Element("input[type=text]", {
                    "id": id,
                    "class": metaValueClass + " search-meta-date " + (metaName + "Date"),
                    "contentType": type
                }).injectInside(metaInputContEl);
                new Element("span", {
                    "id": id + "DateIcon",
                    "class": "pointer ico-search-date search-meta-date-icon",
                    "contentType": type
                }).injectInside(metaInputContEl);

                this.datePickers[metaName] = Librarian.Utils.setUpDatePicker(metaName + "Date", id, id + "DateIcon", this.options.id, this.closeDatePickers.bind(this), this.defaultDateOptions);
            }
            else {
                new Element("input[type=text]", {
                    "id": id,
                    "class": metaValueClass,
                    "spellcheck": "true",
                    "contentType": type
                }).injectInside(metaInputContEl);
            }
        }

        this.onReturnTypeChanged();
        contEl.fireEvent("attributesLoaded", json);
    },

    onAttributeValuesLoaded: function(json, attribName) {
        if (!json || (json.length == 0))
            return;

        this.options.add(new Option('', ''));

        for (var i = 0, length = json.length; i < length; i++)
            this.options.add(new Option(json[i], json[i]));

        // Select the default value 
        if (Librarian.search.defaultAttributeValues) {
            var defaults = Librarian.search.defaultAttributeValues;
            if (defaults[attribName])
                Librarian.Utils.setElementValue(this, defaults[attribName]);
        }
    },

    onMetaCategorySelectClicked: function(meta, inputId) {
        var inputEl = $(inputId);
        if (!inputEl)
            return;

        // Load window with categories in tree view for selection
        var metaWindow = new Librarian.Window.MetaTreeWindow({
            attributeId: meta.id,
            selectedData: JSON.parse(inputEl.get("selectedData") || "[]"),
            checkChildren: Librarian.search.includeCategorizedMetaChildren && Librarian.search.checkCategorizedMetaChildren,
            onSubmit: function(selected) {
                var inputEl = $(inputId);
                if (!inputEl)
                    return;

                var names = selected.map(function(item) {
                    return item.name;
                });

                // Save the full list
                inputEl.set("selectedData", JSON.stringify(selected));

                Librarian.Utils.setElementValue(inputEl, names.join("; "));
            }
        });
        metaWindow.show();
    },

    loadSelectedCategoryName: function() {
        var searchWithinEl = $("searchWithinText");
        if (!searchWithinEl)
            return;
        var searchWithinIDEl = $("searchWithinID");
        if (!searchWithinIDEl)
            return;

        var selected = null,
            tree;
        if (typeof Library.getTreeByType == "function") {
            var catType = Librarian.catType.file;
            if (this.selectedOptionType.contains("Group"))
                catType = Librarian.catType.globalFavorite;
            tree = Library.getTreeByType(catType);
        }
        else
            tree = treeView;
        if (tree)
            selected = tree.getSelected();

        if (selected && (selected.data.contenttype == Librarian.contentType.file))
            selected = selected.getParent();

        // Load in the currently selected category's name from the tree, if there is one
        var name = '',
            id = '';
        if (selected) {
            name = selected.name;
            if (selected.data)
                id = selected.data.catid;
        }

        Librarian.Utils.setElementValue(searchWithinEl, name);
        Librarian.Utils.setElementValue(searchWithinIDEl, id);
    },

    onSearchFileTypeAddClicked: function(e) {
        var evt = new Event(e),
            buttonEl = $(evt.target);
        if (!buttonEl || buttonEl.hasClass("disabled"))
            return;

        // Get the first file type
        var typeEl = $$(".search-file-type")[0];
        if (!typeEl)
            return;

        // Clone it
        var newTypeEl = typeEl.clone();
        newTypeEl.removeClass("left");
        newTypeEl.selectedIndex = 0;
        newTypeEl.addEvent("change", this.loadSearchOptions);

        // Add it to the end of the list of file types
        var parentEl = typeEl.getParent();
        if (parentEl) {
            parentEl = parentEl.getParent() || parentEl;
            parentEl.appendChild(newTypeEl);
        }

        // Re-enable the "Remove" button
        buttonEl = $("searchFileTypeRemoveButton");
        if (buttonEl)
            buttonEl.removeClass("disabled");
    },

    onSearchFileTypeRemoveClicked: function(e) {
        var evt = new Event(e),
            buttonEl = $(evt.target);
        if (!buttonEl || buttonEl.hasClass("disabled"))
            return;

        // If there are 2 file types, there will only be one left so we should disable the remove button
        var typeEls = $$(".search-file-type");
        if (typeEls.length <= 2)
            buttonEl.addClass("disabled");

        // Get the last term and destroy it
        var typeEl = typeEls[typeEls.length - 1];
        typeEl.destroy();

        // Reload the search options so that the destroyed file type doesn't show options now that it's gone
        this.loadSearchOptions();
    },

    onFileTypesLoaded: function(json) {
        if (!json || (json.length == 0))
            return;

        this.fileTypes = [];
        for (var i = 0, length = json.length; i < length; i++) {
            var data = json[i];
            // Don't display undefined types, slides, or pages
            if ((data.FileSubType == Librarian.subType.undefined) || (data.FileSubType == Librarian.subType.slide) || (data.FileSubType == Librarian.subType.page))
                continue;

            this.fileTypes.push({
                ext: data.FileTypeExtension,
                subType: data.FileSubType
            });
        }

        // Sort by extension
        this.fileTypes.sort(function(a, b) {
            if (a.ext < b.ext)
                return -1;
            if (a.ext > b.ext)
                return 1;
            return 0;
        });

        // Add a blank option to make file types optional
        this.fileTypes = [{ ext: "All Types", subType: null }].append(this.fileTypes);
        this.loadFileTypeList();
    },

    loadFileTypeList: function() {
        var extensions = this.getFileTypeExtensions();

        $$(".search-file-type").each(function(el) {
            // Save the selected value to restore later
            var selectedValue = Librarian.Utils.getSelectedValue(el);
            el.options.length = 0;

            Librarian.Utils.fillSelect(el, extensions);
            Librarian.Utils.setSelectValue(el, selectedValue);
        });
    },

    getFileTypeExtensions: function() {
        var subTypes = null,
            searchFor = this.getSelectedSubType();
        // If there is a "Search For" list, get the list of sub types it represents
        if (searchFor)
            subTypes = searchFor.subTypes;

        if (!this.fileTypes)
            return [];

        // Filter out the items with the correct sub type (and leave the default empty one in there too)
        var extensions = this.fileTypes.filter(function(item) {
            return (subTypes == null) || (subTypes.contains(item.subType)) || (item.ext == "All Types");
            // Then pull out just their extensions
        }).map(function(item) {
            return item.ext;
        });

        return extensions;
    },

    clearSearch: function () {
        var options = this.options,
            self = this;

        MUI.updateContent({
            'element': this.panelEl,
            'content': options.content,
            'method': options.method,
            'data': options.data,
            'url': options.contentURL,
            'onContentLoaded': function() {
                self.loaded = false;
                self.onShow();
                self.panelWrapperEl.show();
            },
            'require': {
                js: options.require.js,
                onload: options.require.onload
            }
        });
    },

    submit: function() {
        // If there's no search, we can't continue.
        if (!Librarian.Search) {
            Librarian.Utils.error(Librarian.Lang.getString("search_unavailable"));
            return;
        }

        // Build the search object
        var searched = true,
            search = new Librarian.Search();

        // Load in term (obeying selected search options)
        var termEl = $$(".search-term")[0],
            defaultValue = Librarian.Lang.getString("search_advanced_empty"),
            term = (Librarian.Utils.getElementValue(termEl) || '').trim(),
            searchData = {};

        if (term !== defaultValue)
            searchData[Librarian.Lang.getString("search_term")] = term;
        else if (Librarian.search.allowEmptySearchTerm) {
            searchData[Librarian.Lang.getString("search_term")] = "";
        }

        var searchMethod = null,
            operator = "Contains",
            itemEl = $("searchTermMethod"),
            selectedEl = null;
        if (itemEl) {
            if (itemEl.get("tag") == "select") {
                selectedEl = itemEl.getElement(":selected");
            } else {
                selectedEl = itemEl.getElement(".searchTermRule.selected");
            }

            if (selectedEl) {
                // Get the text for the selected item
                var methodName = selectedEl.get("data-method") || selectedEl.get('text'),
                    // Split on space and convert all values to proper capital case
                    values = methodName.split(' ').invoke("toCapitalCase");

                searchMethod = this.searchMatchRules[methodName];

                // Add the rest of the data to the seach data
                searchData[Librarian.Lang.getString("match")] = values.join(' ');
            }
        }

        itemEl = $("searchReturnType");
        var outputType = Librarian.search.defaultOutputType,
            returnType = null,
            // Load in file sub type
            subType = this.getSelectedSubType(),
            attribType = null,
            optionType = null;

        if (itemEl) {
            var optionEl = $(Librarian.Utils.getSelectedItem(itemEl));
            if (optionEl) {
                returnType = optionEl.get("text");
                attribType = optionEl.get("attribType");
                optionType = optionEl.value;

                var type = optionType.toCapitalCase();
                if ((optionType == "content")) {
                    outputType = Librarian.Search.outputTypes.ALLCONTENT;
                } else if ((optionType == "files") || (optionType == "presentations"))
                    outputType = Librarian.Search.outputTypes.FILES;
                else if ((optionType == "slides") || (optionType == "pages") || (returnType == "Return Group Content"))
                    outputType = Librarian.Search.outputTypes.SLIDES;
                else
                    outputType = Librarian.Search.outputTypes.GROUPS;

                if (returnType == "Return Group Content")
                    type = "Group Content";

                // Set the "Return Results by" header
                searchData[Librarian.Lang.getString("search_returnby")] = (subType ? subType.name + " > " : '') + type;
            }
        }

        var fileFlags = [],
            slideFlags = [],
            groupFlags = [];

        // Keep track of whether to use file and slide keywords
        var includeFileKeyword = false,
            includeSlideKeyword = false,
            includeGroupKeyword = false;

        for (var i = 0, length = Librarian.Search.Panel.returnTypes.length; i < length; i++) {
            var id = "searchReturn" + Librarian.Search.Panel.returnTypes[i].getOptionType() + "Options";
            itemEl = $(id);
            if (itemEl && itemEl.isVisible()) {
                var optionEls = itemEl.getElements(".search-option");
                for (var j = 0, optionLength = optionEls.length; j < optionLength; j++) {
                    if (!optionEls[j].isVisible())
                        continue;

                    var optionEl = optionEls[j].getChildren("label > input")[0];
                    if (!optionEl || !optionEl.checked)
                        continue;

                    var optionParentEl = optionEl.getParent(),
                        value = null,
                        type = -1;
                    if (optionParentEl)
                        value = optionParentEl.get("text").trim();

                    var slideValue = (optionEl.getAttribute("slideValue") || '').trim();
                    if (slideValue.length > 0) {
                        if (!slideFlags.contains(slideValue)) {
                            slideFlags.push(slideValue);
                            type = Librarian.Search.outputTypes.SLIDES;
                        }
                    }

                    var fileValue = (optionEl.getAttribute("fileValue") || '').trim();
                    if (fileValue.length > 0) {
                        if (!fileFlags.contains(fileValue)) {
                            fileFlags.push(fileValue);
                            type = Librarian.Search.outputTypes.FILES;
                        }
                    }

                    var groupValue = (optionEl.getAttribute("groupValue") || '').trim();
                    if (groupValue.length > 0) {
                        if (!groupFlags.contains(groupValue)) {
                            groupFlags.push(groupValue);
                            type = Librarian.Search.outputTypes.GROUPS;
                        }
                    }

                  
                    var searchType = (optionEl.getAttribute("searchType") || '').trim();
                    if (searchType.length > 0) {
                        if (searchType == "slideKW") {
                            if (!includeSlideKeyword)
                                type = Librarian.Search.outputTypes.SLIDES;

                            includeSlideKeyword = true;
                        }
                        else if (searchType == "fileKW") {
                            if (!includeFileKeyword)
                                type = Librarian.Search.outputTypes.FILES;

                            includeFileKeyword = true;
                        }
                        else if (searchType == "groupKW") {
                            if (!includeGroupKeyword)
                                type = Librarian.Search.outputTypes.GROUPS;

                            includeGroupKeyword = true;
                        }
                        else if (searchType == "contentKW") {
                            type = Librarian.Search.outputTypes.ALLCONTENT;

                            includeFileKeyword = true;
                            includeGroupKeyword = true;
                        }
                    }

                    if (outputType == Librarian.Search.outputTypes.ALLCONTENT) {
                        type = Librarian.Search.outputTypes.ALLCONTENT;
                    }

                    // If we added something and we have a valid value
                    if ((value != null) && (value.length > 0)) {
                        var dataName = Librarian.Lang.getArgString("search_options", [Librarian.Search.Panel.returnTypes[i].name]);

                        // Check if we already have data on this option
                        // If not add it, if so, append it
                        if ((typeof searchData[dataName] == "undefined") || (searchData[dataName] == null))
                            searchData[dataName] = { value: value, type: type };
                        else
                            searchData[dataName].value = searchData[dataName].value + ", " + value;
                    }
                }
            }
        }

        // Only search for everything if nothing is checked
        var useAllFlagsOnEmpty = false;
        if ((fileFlags.length == 0) && (slideFlags.length == 0) && (groupFlags.length == 0) && !includeSlideKeyword && !includeFileKeyword && !includeGroupKeyword)
            useAllFlagsOnEmpty = includeSlideKeyword = includeFileKeyword = includeGroupKeyword = Librarian.search.searchAllFlagsIfAllOptionsChecked;

        // Sum the file flag values, if there are any, or use the default value
        if (fileFlags.length == 0)
            fileFlags = useAllFlagsOnEmpty ? -1 : 0;
        else {
            var value = 0;
            for (var i = fileFlags.length; i--;)
                value += fileFlags[i].toInt();
            fileFlags = value;
        }

        // Sum the slide flag values, if there are any, or use the default value
        if (slideFlags.length == 0)
            slideFlags = useAllFlagsOnEmpty ? -1 : 0;
        else {
            var value = 0;
            for (var i = slideFlags.length; i--;)
                value += slideFlags[i].toInt();
            slideFlags = value;
        }

        // Sum the group flag values, if there are any, or use the default value
        if (groupFlags.length == 0)
            groupFlags = useAllFlagsOnEmpty ? -1 : 0;
        else {
            var value = 0;
            for (var i = groupFlags.length; i--;)
                value += groupFlags[i].toInt();
            groupFlags = value;
        }

        // Don't search for group stuff unless we're searching for group stuff
        if (!["groups", "content"].contains(optionType) ) {
            includeGroupKeyword = false;
            groupFlags = 0;
        }

        // If we have a term and it's not the default, add it to the search XML
        if (((term.length >= 0) && (term != defaultValue))) {
            var originalTerm = term;
            if ((searchMethod == "AND") || (searchMethod == "OR"))
                term = Librarian.Search.prepValue(term, null, searchMethod);
            else if ((searchMethod == "EXACT") && !term.isQuoted())
                term = '"' + term + '"';

            var addOriginalTerms = function(func, flags, conjunction, outputType) {
                if ((searchMethod != "EXACT") && !originalTerm.isQuoted()) {
                    // Add each word as its own node
                    var quotedTerms = originalTerm.safeSplit('"'),
                        terms = [],
                        success = true;
                    for (var i = 0, length = quotedTerms.length; i < length; i++) {
                        if (quotedTerms[i].isQuoted())
                            terms.push(quotedTerms[i].replaceAll('"', ''));
                        else
                            terms = terms.concat(quotedTerms[i].split(' '));
                    }
                    for (var i = 0, length = terms.length; i < length; i++) {
                        var value = terms[i].trim();
                        if (value.length == 0)
                            continue;
                        success = success && func(value, conjunction, operator, flags, "OR", null, null, outputType);
                    }
                    return success;
                }
                else
                    Librarian.search.containsWholeWord = true;
                    return func(originalTerm, null, operator, flags, "OR");
            };

            // If there are other terms after description, add those too
            if (fileFlags != 0) {
                if (outputType == Librarian.Search.outputTypes.ALLCONTENT) {
                    searched = searched && addOriginalTerms(search.addFileTerm, fileFlags, searchMethod, Librarian.Search.outputTypes.FILES);
                    searched = searched && addOriginalTerms(search.addFileTerm, fileFlags, searchMethod, Librarian.Search.outputTypes.SLIDES);
                } else {
                    searched = searched && addOriginalTerms(search.addFileTerm, fileFlags, searchMethod);
                }
            }
            if (slideFlags != 0) {
                if (outputType == Librarian.Search.outputTypes.ALLCONTENT) {
                    searched = searched && addOriginalTerms(search.addTextTerm, slideFlags, searchMethod, Librarian.Search.outputTypes.FILES);
                    searched = searched && addOriginalTerms(search.addTextTerm, slideFlags, searchMethod, Librarian.Search.outputTypes.GROUPS);
                    searched = searched && addOriginalTerms(search.addTextTerm, slideFlags, searchMethod, Librarian.Search.outputTypes.SLIDES);
                } else {
                    searched = searched && addOriginalTerms(search.addTextTerm, slideFlags, searchMethod);
                }

            }
            if (groupFlags != 0) {
                if (outputType == Librarian.Search.outputTypes.ALLCONTENT) {
                    searched = searched && addOriginalTerms(search.addGroupTerm, groupFlags, searchMethod, Librarian.Search.outputTypes.GROUPS);
                    searched = searched && addOriginalTerms(search.addGroupTerm, groupFlags, searchMethod, Librarian.Search.outputTypes.SLIDES);
                } else {
                    searched = searched && addOriginalTerms(search.addGroupTerm, groupFlags, searchMethod);
                }
            }

            if (includeSlideKeyword) {
                if (outputType == Librarian.Search.outputTypes.ALLCONTENT) {
                    searched = searched && search.addSlideKeyword(term, null, operator, null, "OR", null, Librarian.Search.outputTypes.FILES);
                    searched = searched && search.addSlideKeyword(term, null, operator, null, "OR", null, Librarian.Search.outputTypes.GROUPS);
                    searched = searched && search.addSlideKeyword(term, null, operator, null, "OR", null, Librarian.Search.outputTypes.SLIDES);
                } else {
                    searched = searched && search.addSlideKeyword(term, null, operator, null, "OR");
                }
              
            }
            if (includeFileKeyword) {
                if (outputType == Librarian.Search.outputTypes.ALLCONTENT) {
                    searched = searched && search.addFileKeyword(term, null, operator, null, "OR", null, Librarian.Search.outputTypes.FILES);
                    searched = searched && search.addFileKeyword(term, null, operator, null, "OR", null, Librarian.Search.outputTypes.SLIDES);
                } else {
                    searched = searched && search.addFileKeyword(term, null, operator, null, "OR");
                }
            }
            if (includeGroupKeyword) {
                if (outputType == Librarian.Search.outputTypes.ALLCONTENT) {
                    searched = searched && search.addGroupKeyword(term, null, operator, null, "OR", null, Librarian.Search.outputTypes.GROUPS);
                    searched = searched && search.addGroupKeyword(term, null, operator, null, "OR", null, Librarian.Search.outputTypes.SLIDES);
                } else {
                    searched = searched && search.addGroupKeyword(term, null, operator, null, "OR");
                }
            }
        }
        else if (Librarian.search.allowEmptySearchTerm) {
            if (fileFlags != 0)
                searched = searched && search.addFileTerm("", searchMethod, Librarian.search.defaultEmptyValueOperator, fileFlags, "OR");
            if (slideFlags != 0)
                searched = searched && search.addTextTerm("", null, Librarian.search.defaultEmptyValueOperator, slideFlags, "OR");
            if (groupFlags != 0)
                searched = searched && search.addGroupTerm("", searchMethod, Librarian.search.defaultEmptyValueOperator, fileFlags, "OR");
        }

        // Load in attributes
        function addMetaValues(type, func, catFunc, outputType) {
            var metaContEl = $("search" + type + "MetaLists");
            if (metaContEl) {
                var hasSearched = true,
                    attrNameEls = metaContEl.getChildren(".search-meta-container .search-meta-name"),
                    attrValueEls = metaContEl.getChildren(".search-meta-container .search-meta-value");

                var conjunction = null;
                if (Librarian.search.attributeConjunction)
                    conjunction = Librarian.search.attributeConjunction;
                else if ((searchMethod == "OR") || (searchMethod == "AND"))
                    conjunction = searchMethod;

                for (var i = 0, attrLength = attrNameEls.length; i < attrLength; i++) {
                    var name = (Librarian.Utils.getElementValue(attrNameEls[i]) || '').trim(),
                        categorized = false,
                        value;

                    if (attrValueEls[i].hasClass("search-meta-categorized")) {
                        categorized = true;

                        var selectedCats = JSON.parse($(attrValueEls[i]).get("selectedData") || "[]");
                        value = selectedCats.map(function(item) {
                            return { name: item.name, catid: item.data.attribcatid };
                        });
                    }
                    else
                        value = (Librarian.Utils.getElementValue(attrValueEls[i]) || '');

                    if (typeof value == "string")
                        value = value.trim();

                    if ((name.length > 0) && (value.length > 0)) {
                        var values;
                        if (typeOf(value) == "array")
                            values = value;
                        else if (attrValueEls[i].tagName == "INPUT")
                            values = value.split(';');
                        else
                            values = [value];

                        var usedTerms = [];
                        for (var j = 0, valLength = values.length; j < valLength; j++) {
                            var val = values[j];
                            if (val != null)
                                val = val.toString();
                            val = (val || '').trim();
                            if (val.length == 0)
                                continue;

                            if (categorized) {
                                hasSearched = hasSearched && catFunc(values[j].catid, values[j].name, name, conjunction, operator, "AND", null, outputType);
                                usedTerms.push(values[j].name);
                            }
                            else {
                                hasSearched = hasSearched && func(val, conjunction, operator, name, "AND", null, outputType);
                                usedTerms.push(val);
                            }
                        }

                        if (usedTerms.length > 0)
                            searchData[name] = usedTerms.join(", ");
                    }
                }

                return hasSearched;
            }

            return true;
        }

        if (attribType == "groups")
            searched = searched && addMetaValues("Groups", search.addGroupAttribute, search.addCategorizedGroupAttribute);
        else if (attribType == "files")
            searched = searched && addMetaValues("Files", search.addFileAttribute, search.addCategorizedFileAttribute);
        else if (attribType == "slides")
            searched = searched && addMetaValues("Slides", search.addSlideAttribute, search.addCategorizedSlideAttribute);
        else if (attribType == "content") {
            searched = searched && addMetaValues("Content", search.addGroupAttribute, search.addCategorizedGroupAttribute, Librarian.Search.outputTypes.GROUPS);
            searched = searched && addMetaValues("Content", search.addFileAttribute, search.addCategorizedFileAttribute, Librarian.Search.outputTypes.FILES);

            var addSlideMetaValues = function(value, conjunction, operator, attributeValue, filterConjunction, createNewFilter, outputType) {
                var filterEl = search.addFileAttributeEx(value, conjunction, operator, attributeValue, "OR", true, null, outputType);
                return search.addGroupAttributeEx(value, conjunction, operator, attributeValue, "OR", false, filterEl, outputType) != null;
            }

            var addSlideCatMetaValues = function(catId, value, name, conjunction, operator, filterConjunction, createNewFilter, outputType) {
                var filterEl = search.addCategorizedFileAttributeEx(catId, value, name, conjunction, operator, "OR", true, null, outputType);
                return search.addCategorizedGroupAttributeEx(catId, value, name, conjunction, operator, "OR", false, filterEl, outputType) != null;

            }
            searched = searched && addMetaValues("Content", addSlideMetaValues, addSlideCatMetaValues, Librarian.Search.outputTypes.SLIDES);
        }

        itemEl = $("searchRequestData");
        if (itemEl) {
            var requestNameEls = itemEl.getChildren(".search-request-container .search-request-name"),
                requestValueEls = itemEl.getChildren(".search-request-container .search-request-value");

            var conjunction = null;
            if ((searchMethod == "OR") || (searchMethod == "AND"))
                conjunction = searchMethod;

            for (var i = 0, requestLength = requestNameEls.length; i < requestLength; i++) {
                var name = (Librarian.Utils.getElementValue(requestNameEls[i]) || '').trim(),
                    value = (Librarian.Utils.getElementValue(requestValueEls[i]) || '').trim();

                if ((name.length > 0) && (value.length > 0)) {
                    searched = searched && search.addRequestTerm(value, conjunction, operator, name.replaceAll(' ', ''), "AND");

                    searchData[name] = value;
                }
            }
        }

        // Load in selected "Search Within" categories, if there are any and they aren't the root
        itemEl = $("searchWithinAll");
        if ((!itemEl || !itemEl.checked) && outputType !== Librarian.Search.outputTypes.ALLCONTENT) {
            var catIDs = [],
                catNames = [];

            itemEl = $("searchWithinID");
            if (itemEl)
                catIDs = (Librarian.Utils.getElementValue(itemEl) || '').trim().split(';');

            itemEl = $("searchWithinText");
            if (itemEl)
                catNames = (Librarian.Utils.getElementValue(itemEl) || '').trim().split(';');

            if (catIDs && catNames && (catIDs.length == catNames.length)) {
                var dataName = Librarian.Lang.getString("search_within_cats"),
                    catType = Librarian.catType.file;

                if (this.selectedOptionType.contains("Group"))
                    catType = Librarian.catType.globalFavorite;

                for (var i = 0, length = catIDs.length; i < length; i++) {
                    if (catIDs[i].trim() == '0')
                        continue;

                    searched = searched && search.addCategory(catIDs[i].trim(), false, catType, null, null, false, null, catNames[i]);

                    // Add the category name to the list of searched categories
                    if ((typeof searchData[dataName] == "undefined") || (searchData[dataName] == null))
                        searchData[dataName] = catNames[i].trim();
                    else
                        searchData[dataName] = searchData[dataName] + ", " + catNames[i].trim();
                }
            }
        }
        else if ((returnType == "Return Group Content") && Librarian.specialCategories && Librarian.specialCategories.GlobalFavorites)
            searched = searched && search.addCategory(Librarian.specialCategories.GlobalFavorites.CatId, false, Librarian.catType.globalFavorite);

        if (Librarian.guestInfo) {
            // Limit search to content available to guest
            var contactId = Librarian.guestInfo.ContactId.toString() || '',
                contactType = Librarian.guestInfo.ContactType.toString() || '',
                eventId = null;

            // Limit search to content for this event, if there is one
            if (Librarian.eventInfo)
                eventId = Librarian.eventInfo.EventId.toString() || '';

            searched = searched && search.addContent(eventId, contactId, contactType, "OR");
        }

        search.deleteEmptyFilters();

        var oldOnBefore = $empty;
        // Save the existing function, is there is one
        if (typeof search.onBeforeXMLGeneration == "function")
            oldOnBefore = search.onBeforeXMLGeneration;

        search.onBeforeXMLGeneration = function() {
            var filterEls = search.xmlDoc.getElementsByTagName("filter");
            for (var i = filterEls.length; i--;) {
                // Load in file types (if they are shown)
                var extensions = 0;
                itemEl = $("searchFileTypes");
                if (itemEl && itemEl.isVisible()) {
                    var fileTypeEls = $$(".search-file-type");
                    for (var j = 0, length = fileTypeEls.length; j < length; j++) {
                        var type = (Librarian.Utils.getSelectedValue(fileTypeEls[j]) || '').trim();
                        // Make sure a valid extension was submitted
                        if ((type.length > 0) && (type != "All Types")) {
                            searched = searched && search.addFileType("extension", type, false, "OR", null, false, filterEls[i]);
                            extensions++;
                        }
                    }
                }

                // Only add the SubType if we're not already looking for specific extensions
                if (extensions == 0) {
                    if (subType) {
                        var types = subType.types || [];
                        for (var j = 0, length = types.length; j < length; j++) {
                            var type = types[j].trim();
                            if (type.length > 0)
                                searched = searched && search.addFileType("subType", type, false, "OR", null, false, filterEls[i]);
                        }
                    }
                }

                // Load in selected last modified dates
                var date = (Librarian.Utils.getElementValue($("minMod_text")) || '').trim();
                if (date.length > 0) {
                    // Add the start date
                    searchData[Librarian.Lang.getString("search_dates")] = date;

                    if (!date.contains(':'))
                        date = date + " 00:00:00";
                    searched = searched && search.addMinModifiedDate(date, null, filterEls[i]);
                }

                date = (Librarian.Utils.getElementValue($("maxMod_text")) || '').trim();
                if (date.length > 0) {
                    // Add the end date
                    var dataName = Librarian.Lang.getString("search_dates");
                    if ((typeof searchData[dataName] == "undefined") || (searchData[dataName] == null))
                        searchData[dataName] = date;
                    else
                        searchData[dataName] = Librarian.Lang.getArgString("search_daterange", [searchData[dataName], date]);

                    if (!date.contains(':'))
                        date = date + " 23:59:59";
                    searched = searched && search.addMaxModifiedDate(date, null, filterEls[i]);
                }
            }

            // Restore the old function or set it to the empty function
            this.onBeforeXMLGeneration = oldOnBefore;
            oldOnBefore();
        };

        var maxResults = Librarian.search.maxResults;
        // Use the ListView handler, if it's enabled
        if (Librarian.listView.enabled && Librarian.ListView != null && (typeof Librarian.ListView.prepSearchGrid == "function"))
            maxResults = Librarian.ListView.prepSearchGrid(search, outputType);
        else if (tileList) {
            search.options.loadComplete = tileList.searchLoadComplete;

            // Show the "Searching..." label
            tileList.reset();
            tileList.wrapper.appendChild(document.createTextNode(Librarian.Lang.getString("searching")));
        }

        var viewName = null;
        if (outputType === Librarian.Search.outputTypes.ALLCONTENT) {
            viewName = "Search";
        }
        else if ((typeOf(Librarian.search.viewNameByType) == "array") && (Librarian.search.viewNameByType.length > outputType))
            viewName = Librarian.search.viewNameByType[outputType];

        // Set the max results, output type, and view name
        searched = searched && search.addResults(null, maxResults, outputType, null, null, viewName, returnType);

        if (searched) {
            // Store this as the last search so we can use pagination
            Librarian.lastSearch = search;

            // Reset the hash
            Librarian.Utils.changeHash('');

            // Execute the search
            search.search();

            // Don't call the function if it doesn't exist
            if (typeof Library.prepSearchPage == "function")
                Library.prepSearchPage('', searchData, null, false);
        }

        Librarian.search.containsWholeWord = false;
    },

    useLastSearchOptions: function() {
        if (!Librarian.lastSearch)
            return;

        this.useSearchOptions(Librarian.lastSearch);
    },

    useSearchOptions: function(search) {
        if (!search)
            return;

        // Load the used terms into the term box
        var termEl = this.contentEl.getElement(".search-term");
        if (termEl) {
            var terms = (search.getSearchTerms() || '').split(';'),
                uniqueTerms = [];

            // Remove all duplicates to make sure we process this correctly
            for (var i = 0, len = terms.length; i < len; i++) {
                var term = (terms[i] || '').trim();
                if (term.length == 0)
                    continue;

                if (!uniqueTerms.contains(term))
                    uniqueTerms.push(term);
            }

            var term = null;
            // Find the first term with a space, if there is one
            // This tries to find the original value that was searched, before it was pre-processed
            for (var i = 0, len = uniqueTerms.length; i < len; i++) {
                if (uniqueTerms[i].contains(' ')) {
                    term = uniqueTerms[i];
                    break;
                }
            }

            // If no term with a space was found then join all unique terms with a space because that is probably what was searched for
            if (!term)
                term = uniqueTerms.join(' ');

            // If there isn't a value set, reset it to the default
            if ((term || '').length == 0)
                term = Librarian.Lang.getString("search_advanced_empty");

            // Set the calculated value
            Librarian.Utils.setElementValue(termEl, term);
        }

        // Set `searchFor` because even though it doesn't exist in QuickSearch, some quick searches use Advanced Search
        // Find <fileType /> and get the type, if it doesn't exist than select "All Files"
        var fileTypeEl = search.xmlDoc.getElementsByTagName("fileType")[0],
            fileType = '';
        if (fileTypeEl)
            fileType = (fileTypeEl.getAttribute("subType") || '').trim();

        if (fileType.length == 0)
            fileType = "All Files";

        // Find the radio element that represents this sub type and click it
        var typeRadioEl = this.contentEl.getElement(".search-radio [name=subType][value=" + fileType + ']');
        if (typeRadioEl && !typeRadioEl.checked)
            typeRadioEl.click();

        // Set the correct return type based on the set output type
        var selectEl = this.contentEl.getElement("#searchReturnType"),
            outputType = (search.getOutputType() || '-1').trim().toInt();
        if (selectEl) {
            switch (outputType) {
                case Librarian.Search.outputTypes.SLIDES:
                    // If we are returning group content select the "Group Content" dropdown option
                    // even though the output type is slides
                    var returnType = search.getReturnType() || '';
                    if (returnType.contains("Group Content"))
                        Librarian.Utils.setSelectValue(selectEl, "groups", function(optionEl) {
                            return (Librarian.Utils.getElementValue(optionEl) || '').contains("Group Content");
                        });
                    else {
                        if (Librarian.Utils.setSelectValue(selectEl, "slides") < 0)
                            Librarian.Utils.setSelectValue(selectEl, "pages");
                    }
                    break;
                case Librarian.Search.outputTypes.GROUPS:
                    Librarian.Utils.setSelectValue(selectEl, "groups");
                    break;
                default:
                    if (Librarian.Utils.setSelectValue(selectEl, "files") < 0)
                        Librarian.Utils.setSelectValue(selectEl, "presentations");
            }
            // Update the UI to reflect that the return type may have changed
            this.onReturnTypeChanged();
        }

        // Build the flag values for each type from the searched options so we know what to check
        var flagFieldEls = search.xmlDoc.selectNodes("//*[@searchFields] | //*[@textTypes]"),
            fileFlags = 0, groupFlags = 0, slideFlags = 0;
        for (var i = 0, length = flagFieldEls.length; i < length; i++) {
            var flagFieldEl = flagFieldEls[i];
            if (!flagFieldEl)
                continue;

            var searchField = (flagFieldEl.getAttribute("searchFields") || '0').trim().toInt(),
                textType = (flagFieldEl.getAttribute("textTypes") || '0').trim().toInt();

            slideFlags |= textType;
            if (flagFieldEl.tagName == "fileTerm")
                fileFlags |= searchField;
            else
                groupFlags |= searchField;
        }

        // Go through each option element and get the flag attribute from it
        var optionEls = this.contentEl.getElements(".search-option input[type=checkbox]"),
            visible = 0;
        for (var i = 0, length = optionEls.length; i < length; i++) {
            var optionEl = optionEls[i];
            if (!optionEl || !optionEl.isVisible()) {
                if (!optionEl.isVisible() && optionEl.checked)
                    optionEl.checked = false;
                continue;
            }
            visible++;

            var fileValue = (optionEl.getAttribute("fileValue") || '0').trim().toInt(),
                groupValue = (optionEl.getAttribute("groupValue") || '0').trim().toInt(),
                slideValue = (optionEl.getAttribute("slideValue") || '0').trim().toInt(),
                searchType = (optionEl.getAttribute("searchType") || '').trim();

            var check = ((fileValue > 0) && ((fileFlags & fileValue) == fileValue)) ||
                ((groupValue > 0) && ((groupFlags & groupValue) == groupValue)) ||
                ((slideValue > 0) && ((slideFlags & slideValue) == slideValue));

            // If there is no flag value, try to get the searchType to see if it there is a keyword
            if (!check && (searchType.length > 0)) {
                switch (searchType) {
                    case "fileKW":
                        check = search.xmlDoc.selectNodes("//fileKeyword/text()").length > 0;
                        break;
                    case "slideKW":
                        check = search.xmlDoc.selectNodes("//slideKeyword/text()").length > 0;
                        break;
                    case "groupKW":
                        check = search.xmlDoc.selectNodes("//groupKeyword/text()").length > 0;
                        break;
                    case "eventGroupKW":
                        check = search.xmlDoc.selectNodes("//eventGroupKeyword/text()").length > 0;
                        break;
                }
            }

            // When selecting a checkbox, call .click on it to trigger the sub-check auto-selection logic
            if (check != optionEl.checked)
                optionEl.click();
        }

        // If we don't show all the boxes as checked when we search all flags, uncheck all the boxes if they are all checked
        var checked = optionEls.filter(function(el) { return el.checked; }).length;
        if (Librarian.search.searchAllFlagsIfAllOptionsChecked && (visible == checked))
            optionEls.forEach(function(el) { el.checked = false; });

        var itemName;
        switch (outputType) {
            case Librarian.Search.outputTypes.SLIDES:
                itemName = "slide";
                break;
            case Librarian.Search.outputTypes.GROUPS:
                itemName = "group";
                break;
            default:
                itemName = "file";
        }

        // Get all of the attributes and their values out of the XML
        // Have to handle mutli-select attributes so group everything here into Name-ValueList pairs
        var attributeEls = search.xmlDoc.selectNodes("//" + itemName + "Attribute | //" + itemName + "CategorizedAttribute"),
            attribValues = {},
            catAttribValues = {};
        for (var i = 0, length = attributeEls.length; i < length; i++) {
            var attributeEl = attributeEls[i];
            if (!attributeEl)
                continue;

            var attribName = (attributeEl.getAttribute("name") || '').trim().replace(' ', '');
            if (attribName.length == 0)
                continue;

            // Handle categorized attributes differently - pull more information and save it in an object
            if (attributeEl.tagName.endsWith("CategorizedAttribute")) {
                if (!catAttribValues[attribName])
                    catAttribValues[attribName] = [];

                var catId = attributeEl.getAttribute("catId"),
                    value = attributeEl.getAttribute("value");
                catAttribValues[attribName].push({
                    name: value,
                    data: {
                        attribcatid: catId
                    }
                });
            }
            else {
                if (!attribValues[attribName])
                    attribValues[attribName] = [];
                attribValues[attribName].push(Librarian.Utils.getXMLNodeText(attributeEl));
            }
        }

        // Set the value of each attribute search option
        var metaContEl = this.contentEl.getElement("#search" + itemName.toCapitalCase() + "sMetaLists") || this.contentEl,
            attribValueEls = metaContEl.getElements("[id$=options]");
        for (var i = 0, length = attribValueEls.length; i < length; i++) {
            var attribValueEl = attribValueEls[i];
            if (!attribValueEl)
                continue;

            var attribName = attribValueEl.id.substring(0, attribValueEl.id.length - "options".length),
                values = attribValues[attribName];
            if (attribValueEl.tagName == "SELECT") {
                if (values && (values.length > 0))
                    Librarian.Utils.setSelectValue(attribValueEl, values);
                else
                    attribValueEl.getElements("option").each(function(el) { el.selected = false });
            }
            else {
                if (values && (values.length > 0)) {
                    for (var i = values.length; i--;)
                        Librarian.Utils.setElementValue(attribValueEl, values[i]);
                }
                else
                    Librarian.Utils.setElementValue(attribValueEl, '');
            }
        }

        // Set the value of each categorized attribute search option
        for (var attribName in catAttribValues) {
            if (!catAttribValues.hasOwnProperty(attribName))
                continue;

            var attribValueEl = metaContEl.getElement('#' + (attribName.replace(' ', '') + "Options").toCapitalCase());
            if (!attribValueEl)
                continue;

            var values = catAttribValues[attribName],
                // Generate the list of values to show in the box by gathering selected names
                valueNames = values.map(function(item) {
                    return item.name;
                });

            // Set the display names and the full data on the text box
            Librarian.Utils.setElementValue(attribValueEl, valueNames.join("; "));
            attribValueEl.set("selectedData", JSON.stringify(values));
        }

        // Load the date values back into their respective text boxes
        var dateEl = search.xmlDoc.getElementsByTagName("dateModified")[0];
        if (dateEl) {
            // Remove the time portion of the value since we're searching on days, not exact times
            var stripTime = function (date) {
                    return date.split(' ')[0];
                },
                min = stripTime((dateEl.getAttribute("min") || '').trim()),
                max = stripTime((dateEl.getAttribute("max") || '').trim());

            if (min.length > 0)
                Librarian.Utils.setElementValue(this.contentEl.getElement("#minMod_text"), min);
            if (max.length > 0)
                Librarian.Utils.setElementValue(this.contentEl.getElement("#maxMod_text"), max);
        }

        // Gather the data for the categories that were searched on
        var categoryEls = search.xmlDoc.getElementsByTagName("category"),
            catIds = [],
            catNames = [];
        for (var i = 0, length = categoryEls.length; i < length; i++) {
            var categoryEl = categoryEls[i];
            if (!categoryEl)
                continue;

            var catId = (categoryEl.getAttribute("catId") || '').trim(),
                catName = (categoryEl.getAttribute("catName") || '').trim(),
                exclude = (categoryEl.getAttribute("exclude") || '').trim();

            // TODO: Skip excluded items because we don't have a way of setting them as "excluded" in the UI yet
            if (exclude == "true")
                continue;

            if (catId.length > 0)
                catIds.push(catId);
            if (catName.length > 0)
                catNames.push(catName);
        }

        // If any categories were found, set the searched category boxes (both displayed and hidden data) to the values that were searched on
        if ((catIds.length > 0) && (catIds.length == catNames.length)) {
            Librarian.Utils.setElementValue(this.contentEl.getElement("#searchWithinText"), catNames.join(';'));
            Librarian.Utils.setElementValue(this.contentEl.getElement("#searchWithinID"), catIds.join(';'));
        }
    },

    doSearchTerm: function(searchTerm) {
        Library.loadTabByName("search") || Library.loadTabByName("advancedsearch");

        var termEl = $$(".search-term")[0];

        Librarian.Utils.setElementValue(termEl, searchTerm);
        this.submit();
    }
});

Librarian.Search.Panel.extend({
    searchFor: [
        {
            name: "Presentations",
            types: ["Presentation"],
            subTypes: [Librarian.subType.presentation],
            showFileTypes: false,
            returnType: { types: ["Presentations", "Slides", "Groups"] }
        },
        {
            name: "Documents",
            types: ["Document"],
            subTypes: [Librarian.subType.document],
            returnType: { types: ["Files", "Pages", "Groups"] }
        },
        {
            name: "Media",
            types: ["Media", "Sound", "Image", "Video", "Movie"],
            subTypes: [Librarian.subType.image, Librarian.subType.media, Librarian.subType.movie, Librarian.subType.sound],
            returnType: { types: ["Files"] },
            showFileSubOptions: false
        },
        {
            name: "All Files",
            returnType: { types: ["Files", "Pages", "Groups"] }
        },
        {
            name: "Globals Only",
            returnType: { types: ["Slides", "Groups"] }
        }
    ],

    returnTypes: [
        {
            name: "Presentations",
            attribType: "files",
            getOptionType: function() {
                return this.name;
            },
            enabled: function() {
                return Librarian.Search.Panel.canSearchFiles();
            }
        },
        {
            name: "Files",
            attribType: "files",
            getOptionType: function() {
                return this.name;
            },
            enabled: function() {
                return Librarian.Search.Panel.canSearchFiles();
            }
        },
        {
            name: "Slides",
            attribType: "slides",
            getOptionType: function() {
                return this.name;
            },
            enabled: function() {
                return Librarian.Search.Panel.canSearchSlides();
            }
        },
        {
            name: "Pages",
            attribType: "slides",
            getOptionType: function() {
                return this.name;
            },
            enabled: function() {
                return Librarian.Search.Panel.canSearchSlides();
            }
        },
        {
            name: "Groups",
            attribType: "groups",
            getOptionType: function() {
                return this.name;
            },
            enabled: function() {
                return Librarian.Search.Panel.canSearchGroups();
            }
        },
        {
            name: "Group Content",
            attribType: "groups",
            getOptionType: function() {
                return "Groups";
            },
            enabled: function() {
                return Librarian.Search.Panel.canSearchGroupContent();
            }
        },
        {
            name: "Content",
            attribType: "content",
            getOptionType: function() {
                return this.name;
            },
            enabled: function() {
                return Librarian.Search.Panel.canSearchFiles();
            }
        }
    ],

    canSearchFiles: function() {
        return true;
    },

    canSearchSlides: function() {
        return true;
    },

    canSearchGroups: function() {
        return true;
    },

    canSearchGroupContent: function() {
        return false;
    },

    getResultsOptionName: function(name) {
        return Librarian.Lang.getArgString("search_return_name", name);
    }
});